import React, { useContext } from "react";
import { Navigate, NavLink, Outlet, useLocation } from "react-router-dom";
import useTitle from "../../hooks/useTitle";
import AuthContext from "../../AuthContext";

const Settings = () => {
  useTitle("Configuración");

  const authContext = useContext(AuthContext);
  const roles = authContext?.user?.roles || [];
  const puedeAdministrarUsuarios = authContext?.can?.("administrar_usuarios") || false;
  // Auditoría 28-ago: "General" no tiene nada usable para operator/seller;
  // "Precios" es exclusiva del admin.
  const veGeneral = roles.some(r => ["admin", "accountant"].includes(r));

  // El index de /settings redirige a "general" para todos: si el rol no ve
  // esa pestaña (o "prices" sin admin), lo mandamos a "Mi cuenta" en vez de
  // dejarlo dentro de un panel sin pestaña.
  const { pathname } = useLocation();
  if ((!veGeneral && pathname.startsWith("/settings/general")) ||
      (!puedeAdministrarUsuarios && pathname.startsWith("/settings/prices"))) {
    return <Navigate to="/settings/me" replace />;
  }

  return (
    <div style={{
      display: "block", padding: "clamp(12px, 2.5vw, 18px) clamp(10px, 3vw, 22px)", background: "#1a1a1a",
      minHeight: "100%", color: "#ddd", fontFamily: "Arial,sans-serif",
      fontSize: 13, textAlign: "left", boxSizing: "border-box", width: "100%",
    }}>
      <div className="mv-screen-title" style={{ fontSize: 16, fontWeight: 700, color: "#fff", marginBottom: 18 }}>
        Configuración
      </div>

      {/* set-tabs: en teléfono las 5 pestañas scrollean lateral en vez de cortarse */}
      <div className="bini-tabs set-tabs" role="tablist">
        {veGeneral && (
          <NavLink to="/settings/general" className={({ isActive }) => `bini-tab${isActive ? " active" : ""}`}>
            General
          </NavLink>
        )}
        {puedeAdministrarUsuarios && (
          <NavLink to="/settings/prices" className={({ isActive }) => `bini-tab${isActive ? " active" : ""}`}>
            Precios
          </NavLink>
        )}
        <NavLink to="/settings/drive" className={({ isActive }) => `bini-tab${isActive ? " active" : ""}`}>
          Google Drive
        </NavLink>
        {puedeAdministrarUsuarios && (
          <NavLink to="/settings/users" className={({ isActive }) => `bini-tab${isActive ? " active" : ""}`}>
            Usuarios
          </NavLink>
        )}
        <NavLink to="/settings/me" className={({ isActive }) => `bini-tab${isActive ? " active" : ""}`}>
          Mi cuenta
        </NavLink>
      </div>

      <div className="bini-tab-panel">
        <Outlet />
      </div>
    </div>
  );
};

export default Settings;
